import { ShipmentsApiAdapter } from '@modules/Invoices/InvoicesOrders/List/adapters/ShipmentsApiAdapter';
import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ShipmentsApiAdapter(httpClient);

export const useOrderInvoicedShipments = (orderId?: number, enabled = true) => {
  return useQuery({
    queryKey: ['orderInvoicedShipments', orderId],
    queryFn: async () => {
      if (!orderId) return { shipments: [], total: 0 };

      return adapter.getShipmentsPaginated({
        page: 1,
        limit: 50,
        searchFilter: {
          filters: [
            { column: 'order_id', operator: 'in', value: [orderId] },
            { column: 'financial_status', operator: 'in', value: ['INVOICED'] },
          ],
          logic: 'AND',
        },
      });
    },
    enabled: Boolean(orderId) && enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
